import { selectAll } from '@codemirror/commands';
import { Compartment, EditorState } from '@codemirror/state';
import { EditorView, keymap } from '@codemirror/view';
import { type RefObject } from 'react';

import { getKeyMaps } from '../utils/key-maps.js';

/**
 * Configures the readonly functionality on the editor.
 * @param readOnly - flag pointing to whether spellcheck is enabled or not
 * @param viewRef - Ref object for the editor
 * @param keymapCompartment -
 */
export const configureReadOnly = (
  readOnly: boolean,
  viewRef: RefObject<EditorView>,
  keymapCompartment: Compartment,
): void => {
  const editorView = viewRef.current;
  editorView.dispatch({
    effects: keymapCompartment.reconfigure([
      EditorState.readOnly.of(readOnly),
      EditorView.editable.of(!readOnly),
      readOnly
        ? keymap.of([{ key: 'Mod-a', run: selectAll }])
        : getKeyMaps(viewRef),
    ]),
  });
};
